import React, { useState } from 'react';
import Logo from '../../Assets/images/logo-rectangle.png';
import { Link } from "react-router-dom";
import { apiurl, backendurl } from '../Config/Config';
import axios from 'axios';
import { FaExclamationTriangle, FaCheck } from "react-icons/fa";
import { AiOutlineLoading } from "react-icons/ai";
import { FaRegFilePdf } from "react-icons/fa6";
import Id_valid from '../../Assets/images/id_valid.png';
import Id_expired from '../../Assets/images/id_expired.png';

const ViewCertificates = () => {

    const [data, setData] = useState('');
    const [errorMsg, setErrorMsg] = useState('');
    const [successMsg, setSuccessMsg] = useState('');
    const [reportNumber, setReportNumber] = useState('ESICO-LFT-');
    const [reportNumberError, setReportNumberError] = useState('');
    const [displayLoader, setDisplayLoader] = useState('none');

    const [verificationType, setVerificationType] = useState('certificate'); // 'certificate' or 'idcard'
    const [fileNumber, setFileNumber] = useState('');
    const [fileNumberError, setFileNumberError] = useState(false);

    const [showPopup, setShowPopup] = useState(false);
    const [popupFile, setPopupFile] = useState('');
    const [name, setName] = useState('');
    const [file_no, setFile_no] = useState('');
    const [civilIdNumber, setCivilIdNumber] = useState('');
    const [designation, setDesignation] = useState('');
    const [expiryDate, setExpiryDate] = useState('');


    const handleFormSubmit = (e) => {
        e.preventDefault();
        setErrorFree();

        if (verificationType === 'certificate') {
            if (!reportNumber) {
                setReportNumberError(true);
                setErrorMsg('Enter the report number');
                scrollToTop();
                return;
            }
            postData({ reportNumber }, 'certificate');
        } else {
            if (!fileNumber) {
                setFileNumberError(true);
                setErrorMsg('Enter the file number');
                scrollToTop();
                return;
            }
            postData({ file_number: fileNumber }, 'idcard');
        }
    };


    const postData = async (postObject, type) => {
        setDisplayLoader('inline-block');
        var qs = require('qs');
        const endpoint = type === 'certificate' ? 'certificates/list_for_verification' : 'idcards/list_for_verification';

        let newTab;

        if (type === 'certificate') {
            // Open the tab immediately
            newTab = window.open("", "_blank");
        }

        try {
            const response = await axios.post(apiurl + endpoint, qs.stringify(postObject));
            if (response && response.data.status === "success") {
                setErrorFree();
                if (type === 'certificate') {
                    // redirectPDF(response.data.data);
                    newTab.location.href = "/viewPDF/" + response.data.data;
                } else {
                    // Get file from API response and show popup
                    const responseData = response.data.data;
                    setName(responseData.name);
                    setFile_no(responseData.file_number);
                    setCivilIdNumber(responseData.civil_id_number);
                    setDesignation(responseData.designation);
                    setExpiryDate(responseData.expiry_date);
                    setPopupFile(responseData.file);
                    setShowPopup(true);
                }
            } else {
                setErrorFree();
                setErrorMsg(response.data.message);
                scrollToTop();
                newTab.close();
            }
        } catch (err) {
            setErrorMsg('An error occurred. Please try again.');
            scrollToTop();
        } finally {
            setDisplayLoader('none');
        }
    };

    const toTitleCase = (str) => {
        return str
            .toLowerCase()                          // optional: ensure consistent casing
            .split(' ')                             // split into words
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };

    const redirectPDF = (unique_id) => {
        window.open("/viewPDF/" + unique_id, "_blank");
    }

    const setErrorFree = () => {
        setErrorMsg('');
        setSuccessMsg('');
        setReportNumberError(false);
        setDisplayLoader('none');
    }

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const isExpired = () => {
        if (!expiryDate) return false;

        const parts = expiryDate.split('-'); // format: YYYY-MM-DD
        const year = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1; // month is 0-based
        const day = parseInt(parts[2], 10);

        // Create date with time set to 23:59:59
        const expiry = new Date(year, month, day, 23, 59, 59);
        const now = new Date();

        return expiry < now;
    };

    return (
        <div className="container-scroller">
            <div className="container-fluid page-body-wrapper full-page-wrapper">
                <div className="content-wrapper d-flex align-items-center auth">
                    <div className="row flex-grow">
                        <div className="col-lg-4 mx-auto">
                            <div className="auth-form-light text-left p-5">
                                <div className="brand-logo">
                                    <img src={Logo} />
                                </div>
                                <h4>Hey! Quickly Verify Your Certificates Here.</h4>
                                {/* <h6 className="font-weight-light">Report Number</h6> */}
                                <div className='err-display' style={{ display: (errorMsg) ? 'block' : 'none' }}> <FaExclamationTriangle /> <p>{errorMsg}</p></div>
                                <div className='success-display' style={{ display: (successMsg) ? 'block' : 'none' }}> <FaCheck /> <p>{successMsg}</p></div>
                                <form className="pt-3" onSubmit={handleFormSubmit} autoComplete="off">
                                    <div className="form-group">
                                        <label><strong>Select Type:</strong></label><br />
                                        <div>
                                            <label style={{ marginRight: '15px' }}>
                                                <input
                                                    type="radio"
                                                    name="verificationType"
                                                    value="certificate"
                                                    checked={verificationType === 'certificate'}
                                                    onChange={(e) => setVerificationType(e.target.value)}
                                                /> Certificate
                                            </label>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="verificationType"
                                                    value="idcard"
                                                    checked={verificationType === 'idcard'}
                                                    onChange={(e) => setVerificationType(e.target.value)}
                                                /> ID Card
                                            </label>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        {verificationType === 'certificate' ? (
                                            <input
                                                type="text"
                                                className={reportNumberError ? "form-control form-control-lg err-field" : "form-control form-control-lg"}
                                                placeholder="Report Number"
                                                onChange={(e) => setReportNumber(e.target.value)}
                                                value={reportNumber}
                                                style={{ textTransform: "uppercase" }}
                                            />
                                        ) : (
                                            <input
                                                type="text"
                                                className={fileNumberError ? "form-control form-control-lg err-field" : "form-control form-control-lg"}
                                                placeholder="File Number"
                                                onChange={(e) => setFileNumber(e.target.value)}
                                                value={fileNumber}
                                                style={{ textTransform: "uppercase" }}
                                            />
                                        )}

                                    </div>
                                    <div className="mt-3">
                                        <button className="btn btn-block btn-gradient-primary btn-lg font-weight-medium auth-form-btn" type="submit" disabled={(displayLoader == 'inline-block' ? 'disabled' : '')} >Search</button>
                                        <AiOutlineLoading className='loader' display={displayLoader} />
                                    </div>
                                </form>
                                {/* <div className="verify-pdf-list">
                                    {data.length > 0 && data.map(item => (
                                        <div className="pdf-icon-par"><a className="pdf-icon-link" href={"/viewPDF/" + item.unique_id} target="_blank"><FaRegFilePdf className="pdf-icon" /><p className="pdf-icon-report-number">{item.report_number}</p></a></div>
                                    ))}
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {showPopup && (
                <div className="modal-backdrop">
                    <div className="modal-box view-modal" style={{ maxHeight: '80vh', overflowY: 'auto', textAlign: 'left', position: 'relative' }}>
                        <h4>ID Card Preview</h4>
                        <button className='btn btn-light' style={{ position: 'absolute', top: '10px', right: '10px' }} onClick={() => setShowPopup(false)}>Close</button>
                        <div className="form-group row" style={{ marginBottom: 0 }}>
                            <div className='col-sm-6'><label><strong>Name:</strong> &nbsp; {toTitleCase(name)}</label></div>
                            <div className='col-sm-6'><label><strong>Designation:</strong> &nbsp; {toTitleCase(designation)}</label></div>
                        </div>
                        <div className="form-group row" style={{ marginBottom: 0 }}>
                            <div className='col-sm-6'><label><strong>File Number:</strong> &nbsp; {fileNumber.toUpperCase()}</label></div>
                            <div className='col-sm-6'><label><strong>Civil ID (IQAMA):</strong> &nbsp; {toTitleCase(civilIdNumber)}</label></div>
                        </div>
                        <div className="form-group row" style={{ marginBottom: 0 }}>
                            <div className='col-sm-6'><label><strong>Expiry Date:</strong> &nbsp; {toTitleCase(expiryDate)}</label></div>
                        </div>
                        {popupFile ? (
                            <div style={{ position: 'relative' }}>
                                {popupFile.endsWith('.pdf') ? (
                                    <iframe
                                        src={`${backendurl}uploads/idcards/${popupFile}#toolbar=0`}
                                        width="100%"
                                        height="500px"
                                        style={{ border: 'none' }}
                                    ></iframe>
                                ) : (
                                    <img src={`${apiurl}uploads/idcards/${popupFile}`} alt="ID Card" style={{ maxWidth: '100%' }} />
                                )}
                                <div
                                    className='id-card-status-watermark'
                                    style={{
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        transform: 'translate(-50%, -50%) rotate(-30deg)',
                                        opacity: 0.4,            // adjust transparency
                                        pointerEvents: 'none',
                                    }}
                                >
                                    <img
                                        src={isExpired() ? Id_expired : Id_valid}
                                        alt={isExpired() ? 'Expired' : 'Valid'}
                                        style={{ maxWidth: '100%', height: 'auto' }} // adjust size as needed
                                    />
                                </div>

                            </div>
                        ) : (
                            <p>File not found</p>
                        )}

                        <button className='btn btn-light' onClick={() => setShowPopup(false)}>Close</button>
                    </div>
                </div>
            )}

        </div>
    )
}

export default ViewCertificates